import AllergyAqiLineChartCompare from '../TrendCharts/AllergyAqiLineChartCompare'
import { React, useState, useEffect } from 'react'
import ErrorLogs from '../../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../../components/AuthProvider'
import { useGeoState } from '../../../components/GeoProvider'
import {startDate,endDate} from '../dates'
import { useGeoFetch } from '../../../components/GeoProvider'
import Spinner from '../../../components/Loader/Spinner'
import ErrorMessage from '../../../components/Layout/ErrorMessage'

const TrendChart = ({ geo_id,geo_type,data_type }) => {
    const [getAllergyData, setAllergyData] = useState()
    const [getStaticData, setStaticData] = useState()
    const { user } = useAuthState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [isStaticDataLoading,setIsStaticDataLoading]=useState(false)
  const [isAllergyDataLoading,setIsAllergyDataLoading]=useState(false)
    const {
    diseaseSelected
  } = useGeoState()
  const { data: staticData, error: staticDataError } = useGeoFetch(
    startDate,
    endDate,
    'allergiesstaticdata',
    '',
    '',
    {
      'table_type' : 'ALLERGY', 
      'disease_id' : diseaseSelected
    }
  )

  useEffect(() => {
    setIsStaticDataLoading(true)
    // setStaticData(undefined)
    if (staticData !== null && staticData !== undefined) {
      if (staticData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setStaticData(staticData.response_data)
      } else {
        // setStaticData(null)
        setErrorCode(staticData.response_code)
        setErrorMessage(staticData.response_message)
        setErrorSubject(staticData.response_subject)
        seterrorOccured(true)
      }
      setIsStaticDataLoading(false)
    }
  }, [staticData,diseaseSelected,isStaticDataLoading])

  const { data: statesData, error: MapError } = useGeoFetch(
    startDate,
    endDate,
    'allergiesairqualitytrend',
    `${geo_type}/${diseaseSelected}`,
    '',
    {
      'geo_id' : geo_id
    }
  )

  useEffect(() => {
    setIsAllergyDataLoading(true)
    // setAllergyData(undefined)
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setAllergyData(statesData.response_data)
      } else {
        // setAllergyData(null)
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
      setIsAllergyDataLoading(false)
    }
  }, [statesData,diseaseSelected,isAllergyDataLoading])


  if (
    MapError ||
    errorOccured ||
    staticDataError 
  ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }


const dataCategory =(getStaticData!==undefined&&isStaticDataLoading!==true&&
getStaticData.map((season) => {
  return {
    value: season.data_id,
    label: season.display_value,
  }
}))

  let chartData=[]

  getAllergyData!==undefined&&isAllergyDataLoading!==true&&getAllergyData.map((data_val) => {
    let jsonData=JSON.parse(data_val.json_value)
    let lineData=[]
    let disease_id=""
    let disease_name=""
    jsonData.map((value)=>{
        lineData.push([Date.parse(new Date(value.week_ending)),
          parseInt(value.data_value===null?0:value.data_value)])
        disease_id=value.disease_id
        disease_name=value.disease_name
    })
    let obj={
        "disease_id": disease_id,
        "season": disease_name,
        "geo_type": geo_id,
        "json_value": lineData
    }
    chartData.push(obj)
    
  })

    return(
        getAllergyData!==undefined&&
        getStaticData!==undefined&&
        isAllergyDataLoading!==true&&
        isStaticDataLoading!==true
         ? (<AllergyAqiLineChartCompare 
            chartData={chartData}
            dataCategory={dataCategory}
            geo_type={geo_type} 
            geo_id={geo_id} 
            data_type={data_type} />):<Spinner/>
    ) 
}
export default TrendChart